/*function getDeliveryDate() {
  const daysOfWeek = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
  const monthsOfYear = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
  //const today = new Date('Tue Aug 5 2024 15:11:40 GMT-0600');
  const today = new Date();
  const currentHour = today.getHours();
  const currentMinutes = today.getMinutes();
  const currentDay = today.getDay();

  let deliveryDate = new Date(today);

  // Function to add business days
  function addBusinessDays(date, days) {
    let countDays = 0;
    while (countDays < days) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) { // If not Sunday (0) or Saturday (6)
        countDays++;
      }
    }
    return date;
  }

  if (currentDay >= 1 && currentDay <= 4) { // Monday to Thursday
    if (currentHour < 15 || (currentHour === 15 && currentMinutes === 0)) {
      deliveryDate.setDate(today.getDate() + 1);
    } else {
      deliveryDate = addBusinessDays(today, 2);
    }
  } else if (currentDay === 5) { // Friday
    if (currentHour < 17 || (currentHour === 17 && currentMinutes === 0)) {
      deliveryDate.setDate(today.getDate() + 1);
    } else {
      deliveryDate.setDate(today.getDate() + 2); // Immediate Monday
    }
  } else if (currentDay === 6) { // Saturday
    deliveryDate.setDate(today.getDate() + 2); // Immediate Monday
  } else { // Sunday
    deliveryDate.setDate(today.getDate() + 1); // Immediate Monday
  }

  const dayName = daysOfWeek[deliveryDate.getDay()];
  const monthName = monthsOfYear[deliveryDate.getMonth()];
  const day = deliveryDate.getDate();

  return `${dayName}, ${day} ${monthName}`;
}

document.addEventListener('DOMContentLoaded', function() {
  const dateElement = document.getElementById('date__estimated');
  if (dateElement) {
    let date = getDeliveryDate();
    dateElement.textContent = date;
  }
});*/

/* function getDeliveryDate() {
  const daysOfWeek = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];
  const monthsOfYear = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
  
  const today = new Date('08/12/2024 10:11:40');
  today.setHours(11);
  today.setMinutes(11);
  today.setSeconds(0);

  let today = luxon.DateTime.now().setZone('America/Mexico_City').toISO();
  today = new Date(today);

  const currentHour = today.getHours();
  const currentMinutes = today.getMinutes();
  const currentDay = today.getDay();

  let deliveryDate = new Date(today);

  // Function to add business days
  function addBusinessDays(date, days) {
    let countDays = 0;
    while (countDays < days) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) { // If not Sunday (0) or Saturday (6)
        countDays++;
      }
    }
    return date;
  }

  if (currentDay >= 1 && currentDay <= 4) { // Monday to Thursday
    if (currentHour < 15 || (currentHour === 15 && currentMinutes === 0)) {
      deliveryDate.setDate(today.getDate() + 1);
    } else {
      deliveryDate.setDate(today.getDate() + 2);
    }
  } else if (currentDay === 5) { // Friday
    if (currentHour < 17 || (currentHour === 17 && currentMinutes === 0)) {
      deliveryDate.setDate(today.getDate() + 1);
    } else {
      deliveryDate.setDate(today.getDate() + (8 - currentDay)); // Immediate Monday
    }
  } else if (currentDay === 6) { // Saturday
    deliveryDate.setDate(today.getDate() + 2); // Immediate Monday
  } else { // Sunday
    deliveryDate.setDate(today.getDate() + 1); // Immediate Monday
  }

  const dayName = daysOfWeek[deliveryDate.getDay()];
  const monthName = monthsOfYear[deliveryDate.getMonth()];
  const day = deliveryDate.getDate();

  return `${dayName}, ${day} de ${monthName}`;
}

document.addEventListener('DOMContentLoaded', function() {
  const dateElement = document.getElementById('date__estimated');
  if (dateElement) {
    let date = getDeliveryDate();
    dateElement.textContent = date;
  }
}); */

function addBusinessDays(date, days) {
  let businessDaysAdded = 0;
  let currentDate = new Date(date);

  while (businessDaysAdded < days) {
    currentDate.setDate(currentDate.getDate() + 1); // Avanzar un día
    const dayOfWeek = currentDate.getDay(); // 0 (Domingo) - 6 (Sábado)
    if (dayOfWeek !== 0 && dayOfWeek !== 6) { // Evitar fines de semana
      businessDaysAdded++;
    }
  }
  return currentDate;
}

function getDeliveryDateVariant() {
  const now = new Date();
  const timeZoneOffset = -6 * 60; // UTC-6 para América/México_City
  const nowLocal = new Date(now.getTime() + now.getTimezoneOffset() * 60000 + timeZoneOffset * 60000);

  const dayOfWeek = nowLocal.getDay(); // 0 (Domingo) - 6 (Sábado)
  const hour = nowLocal.getHours();
  const minute = nowLocal.getMinutes();

  let sendDate = nowLocal;

  if (dayOfWeek >= 5 || dayOfWeek === 6 || dayOfWeek === 0) { // Viernes (5), Sábado (6), o Domingo (0)
    const daysUntilMonday = (8 - dayOfWeek) % 7;
    sendDate.setDate(sendDate.getDate() + daysUntilMonday);
  } else if (hour > 13 || (hour === 13 && minute > 30)) {
    sendDate = addBusinessDays(sendDate, 2);
  } else {
    sendDate = addBusinessDays(sendDate, 1);
  }

  return sendDate;
}

function getEstimatedDeliveryDates(sendDate) {
  const positiveDelivery = addBusinessDays(new Date(sendDate), 2);
  const negativeDelivery = addBusinessDays(new Date(sendDate), 5);

  return { positiveDelivery, negativeDelivery };
}

function formatDateShort(date) {
  const options = { weekday: 'short', day: '2-digit', month: 'short' };
  return date.toLocaleDateString('es-ES', options);
}

document.addEventListener('DOMContentLoaded', () => {
  const sendDate = getDeliveryDateVariant();
  const { positiveDelivery, negativeDelivery } = getEstimatedDeliveryDates(sendDate);

  const formattedSendDate = formatDateShort(sendDate);
  const formattedPositiveDelivery = formatDateShort(positiveDelivery);
  const formattedNegativeDelivery = formatDateShort(negativeDelivery);

  const sendDateSpan = document.getElementById('date__send');
  const deliveryDateSpan = document.getElementById('date__delivery');

  sendDateSpan.textContent = `${formattedSendDate}`;
  deliveryDateSpan.textContent = `${formattedPositiveDelivery} - ${formattedNegativeDelivery}`;
});
